'use client';

import {
  requestGetBrandMyHeart,
  requestGetContentsMyHeart,
  requestGetMyHeartItems,
} from '@apis/renewal/myHeart';
import useGlobalState from '@hooks/useGlobalState';
import { getCookieWckAuthData } from '@wconcept/wconcept-common/utils/cookie';
import { useCallback, useContext, useEffect, useState } from 'react';

function MyHeartManager() {
  const { assistData, setProductMyHeart, setBrandMyHeart, setContentsMyHeart } =
    useGlobalState();
  const [isMount, setIsMount] = useState(false);

  const getWckAuthData = useCallback(async () => {
    const res = await getCookieWckAuthData();
    return res;
  }, []);

  const getItemMyHeartList = useCallback(async () => {
    try {
      const wckAuthData = await getWckAuthData();
      if (wckAuthData?.userNo && wckAuthData?.userNo !== '0') {
        const res = (await requestGetMyHeartItems()) || [];
        setProductMyHeart(res);
      }
    } catch (e) {
      console.error(e);
    }
  }, [getWckAuthData, setProductMyHeart]);

  const getBrandMyHeartList = useCallback(async () => {
    try {
      const wckAuthData = await getWckAuthData();
      if (wckAuthData?.userNo && wckAuthData?.userNo !== '0') {
        const res = (await requestGetBrandMyHeart()) || [];
        setBrandMyHeart(res);
      }
    } catch (e) {
      console.error(e);
    }
  }, [assistData, setBrandMyHeart]);

  const getContentsMyHeartList = useCallback(async () => {
    try {
      const wckAuthData = await getWckAuthData();
      if (wckAuthData?.userNo && wckAuthData?.userNo !== '0') {
        const res = (await requestGetContentsMyHeart()) || [];
        setContentsMyHeart(res);
      }
    } catch (e) {
      console.error(e);
    }
  }, [assistData, setContentsMyHeart]);

  const handleMyHeartItem = useCallback(async () => {
    const wckAuthData = await getWckAuthData();
    if (wckAuthData?.userNo && wckAuthData?.userNo !== '0') {
      getItemMyHeartList();
      getBrandMyHeartList();
      getContentsMyHeartList();
    } else {
      setProductMyHeart([]);
      setBrandMyHeart([]);
      setContentsMyHeart([]);
    }
  }, [
    assistData,
    getItemMyHeartList,
    getBrandMyHeartList,
    getContentsMyHeartList,
    setProductMyHeart,
    setBrandMyHeart,
    setContentsMyHeart,
  ]);

  useEffect(() => {
    setIsMount(true);
  }, []);

  useEffect(() => {
    if (isMount) {
      handleMyHeartItem();
    }
  }, [isMount, assistData?.user?.userNo]);

  const handlePageShow = useCallback(() => {
    handleMyHeartItem();
  }, [handleMyHeartItem]);

  const handleVisibilityChange = useCallback(() => {
    if (document.visibilityState === 'visible') {
      handleMyHeartItem();
    }
  }, [handleMyHeartItem]);

  useEffect(() => {
    window.addEventListener('pageshow', handlePageShow);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
}

export default MyHeartManager;
